import { createFileRoute } from "@tanstack/react-router";
import { KeywordServiceLanding } from "@/components/KeywordServiceLanding";
import { keywordServiceHead } from "@/lib/keywordServicePages";
import { getTownMarketingPage } from "@/lib/townMarketingPages";

const PAGE = getTownMarketingPage("pueblo-west");

export const Route = createFileRoute("/marketing-pueblo-west")({
  head: () => keywordServiceHead(PAGE),
  component: () => <KeywordServiceLanding page={PAGE} />,
});
